import { GroupBySaleSummaryEnum } from '@/core/domain/reports/financial/directSale/DirectSale.types';
import { Form, Radio, Typography } from 'antd';
import { useIntl } from 'react-intl';

export default function DirectSaleSummaryOption() {
  const intl = useIntl().formatMessage;
  const { Title } = Typography;

  const groupByOptions = [
    {
      value: GroupBySaleSummaryEnum.SITUATION,
      label: intl({ id: 'movementDirectSale.option.situation' }),
    },
    {
      value: GroupBySaleSummaryEnum.DAILY,
      label: intl({ id: 'movementDirectSale.option.diary' }),
    },
    {
      value: GroupBySaleSummaryEnum.MONTHLY,
      label: intl({ id: 'movementDirectSale.option.monthly' }),
    },
  ];

  return (
    <Form.Item
      name="groupBySaleSummary"
      label={
        <Title level={5} style={{ margin: '0' }}>
          {intl({ id: 'movementDirectSale.label.groupReportBy' })}
        </Title>
      }
      initialValue="SITUATION"
    >
      <Radio.Group
        options={groupByOptions}
        buttonStyle="solid"
        optionType="button"
        size="large"
      />
    </Form.Item>
  );
}
